/**
 * PATH: packages/job-hub/src/jobs/qa/qaJobLibrary.ts
 * FILE_ID: JOBHUB-QA-JOB-LIBRARY-001
 * PURPOSE: Match a device file to one already on this job's Files rail.
 */
export interface QaLibraryRow {
  id: string
  filename: string
  content_type?: string
  file_size?: number | null
}

export function uploadNameKey(name: string): string {
  return (name || '').trim().toLowerCase().replace(/[\s_]+/g, ' ')
}

export function existingLibraryMatch(files: QaLibraryRow[], file: File): QaLibraryRow | null {
  const key = uploadNameKey(file.name)
  const image = (file.type || '').startsWith('image/')
  return files.find((row) => {
    if (uploadNameKey(row.filename) !== key) return false
    if (!image) return true
    return row.file_size === file.size
  }) ?? null
}

export async function assetForDeviceFile(
  file: File,
  list: () => Promise<QaLibraryRow[]>,
  upload: (file: File) => Promise<{ id: string }>,
): Promise<string> {
  const match = existingLibraryMatch(await list(), file)
  if (match) return match.id
  const created = await upload(file)
  return created.id
}
